import { reactive, ref, onMounted, onBeforeUnmount, watch, nextTick, defineComponent } from '@vue/composition-api';
import type { Data, Ref } from '@vue/composition-api';

import objectFitImages from 'object-fit-images'; //图像比例自适应兼容IE

//import HowlerObject from 'howler';

import { Message, Modal, Btn } from '@/components/UI';

import { musicPlayer as musicPlayerConfig } from '@/config';

/*引入SVG图标库 */
import {
	SvgPauseCircle,
	SvgPlayCircle,
	SvgSkipForward,
	SvgSkipBack,
	SvgVolume,
	SvgVolumeLite,
	SvgVolumeMute,
	SvgRepeatOnce,
	SvgRepeatList,
	SvgSwitch,
	SvgList,
	SvgPlay,
	SvgPause,
	SvgLoader,
	SvgStop,
	SvgChevrons,
} from './svg';
//引入方法库
import methods from './methods';
import { DatePicker } from 'view-design';

import store from '@/store';
import Playlist from '@/pages/Music/Playlist';
import { getArea } from '@/api';
import { mergeArrayForNumArr } from '@/public/methods';

//解析前的歌词
type Lrc = string;
interface KaraokeProgram {
	wordCount: number;
	start: number;
	end: number;
}
interface Lyric {
	time: number;
	text: string;
	group?: number | string;
	karaokeData?: KaraokeProgram[]; //卡拉OK方式显示歌词时的句点
}

interface PlayList {
	onlyid?: string | number;
	title: string;
	author: string;
	url: string;
	albumimg: string;
	duration?: number;
	lrc?: Lrc;
	lyric: Lyric[];
}
interface BgmData {
	config: {
		autoplay: boolean;
		playmode: number;
	};
	playlist: PlayList[];
}

interface Status extends Data {
	playState: number;
	isPlaying: boolean;
	isBuffering: boolean;
	isSeeking: boolean;
	track: number;
	bufferTime: any[];
	currentTime: number;
	remainingTime: number;
	totalTime: number;
	volume: number;
	playMode: number;
}

interface BtnsControl {
	key: string;
	ico: string;
	title: string;
	methodName: string;
}
interface BtnsExtra {
	name: string;
	title: string;
}
interface Btns extends Data {
	control: BtnsControl[];
	extra: BtnsExtra[];
}
//const { Howl, Howler }: any = HowlerObject;

const imgBenchUrl =
	'data:image/png;base64,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';

let isActivePage = false;

let isOnlyReceiveOutCommand = false;
let isOutCommandOTP = false; //调用外部指令后一次性生效

export default defineComponent({
	components: {
		SvgPauseCircle,
		SvgPlayCircle,
		SvgSkipForward,
		SvgSkipBack,
		SvgVolume,
		SvgVolumeLite,
		SvgVolumeMute,
		SvgRepeatOnce,
		SvgRepeatList,
		SvgSwitch,
		SvgList,
		Message,
		Modal,
		SvgPlay,
		SvgPause,
		SvgLoader,
		SvgStop,
		SvgChevrons,
		Btn,
	},
	setup(props: any, { root }: any) {
		const { $message, $modal, $tip, $router } = root;
		const isIE: Ref<boolean> = ref(!!/Trident/.test(navigator.userAgent));
		let isInit = false;
		let Obj: any; //
		let lastPlayStateForDocumentHidden = -1;
		let isCanPlay = false;
		let randomList: number[] = [];
		//播放器的配置信息
		const config: Data = reactive({
			isShowList: false,
			isShowTimeRemaining: false,
			listScreenKey: 0, //0旋转专辑，1歌词，2列表
		});
		//播放器的状态
		const status: Status = reactive({
			playState: 0, //0未知1停止2暂停3播放4快进5快退6缓冲7等等8完毕9切换10就绪1001出错
			isPlaying: false,
			isBuffering: false, //正在缓冲
			isSeeking: false, //正在加载
			track: 0, //当前第几首曲目
			bufferTime: [], //当前歌曲缓冲了多少时间,数组的等式{start:0,end:5}[]
			currentTime: 0, //当前时间
			remainingTime: -1, //剩余时间
			totalTime: -1, //当前歌曲总时间
			volume: 1,
			playMode: 3, //1单曲循环2列表循环3随机播放
			currentLyric: '', //
			currentFrom: '', //
		});
		//接收缓存的内容
		const touchBuffered = () => {
			if (typeof Obj !== 'object' || Obj === null) {
				return;
			}
			const { buffered } = Obj;
			const arr = [];
			for (let i = 0; i < buffered.length; i++) {
				arr[i] = {
					start: buffered.start(i),
					end: buffered.end(i),
				};
			}
			status.bufferTime = [...arr];
			//console.log(arr);
		};
		//当前的播放列表
		const playList: Ref<PlayList[]> = ref([]);
		//当前正在播放
		const nowPlay: Ref<PlayList | any> = ref({});
		//每次播放列表发生变化时都重新载入播放器
		//watch(
		//	() => playList.value,
		//	() => init({ isAutoPlay: false })
		//);
		//监听每次路由发生变化时，隐藏播放器的列表/详情页
		$router.afterEach(() => {
			config.isShowList = false;
		});
		//设置每次开启组件时可读取一次外部指令
		onMounted(() => {
			isOnlyReceiveOutCommand = false;
		});
		//播放器组件加载 -> 读取播放列表 -> 播放特定曲目
		//初始化播放器
		const init = (options: { isAutoPlay: boolean; playlist: PlayList[] | undefined } = { isAutoPlay: true, playlist: undefined }) => {
			unistall();
			try {
				Obj.remove();
			} catch (e) {
				//
			}
			isInit = false;
			//发送异步请求
			return new Promise((resolve, reject) => {
				/*
				if (playList.value.length <= 0) {
					reject('播放列表没有任何歌曲');
					return;
				}
				setTimeout(() => {
					resolve('ok');
				}, 1);
				*/
				//获取背景音乐和配置信息
				if (!options.playlist || options.playlist.length <= 0) {
					getArea('MUSIC_BGM')
						.then((data: any) => {
							//console.log(data);
							data as BgmData;
							status.playmode = data.config.playmode;
							playList.value = [...data.playlist];
							resolve('ok');
						})
						.catch(error => reject(error));
				} else {
					playList.value = [...options.playlist];
					resolve('ok');
				}
			})
				.then(() => {
					try {
						Obj = new window.Audio();
						Obj.setAttribute('preload', 'true');
						//Obj.setAttribute('crossorigin', 'anonymous');
					} catch (e) {
						throw '无法初始化播放器:' + e;
					}
					if (!Obj) {
						throw '无法初始化播放器';
					}
					Obj.addEventListener('loadeddata', () => {
						if (Obj && Obj.duration) {
							status.totalTime = isNaN(Obj.duration) ? -1 : Obj.duration;
						}
					});
					Obj.addEventListener('timeupdate', () => {
						if (!Obj || !Obj.currentTime) {
							return;
						}
						status.currentTime = isNaN(Obj.currentTime) ? 0 : Obj.currentTime;
						status.totalTime = isNaN(Obj.duration) ? -1 : Obj.duration;
						touchBuffered(); //获取缓冲的区域
					});
					Obj.addEventListener('ended', () => {
						//播放完毕时
						control('autoNext');
					});
					Obj.addEventListener('error', (error: any) => {
						//出错时
						//throw '播放器出错:' + error;
						status.playState = 1001;
						status.isPlaying = false;
						console.warn('播放器出错', error);
						$message.error('播放器出错');
					});
					Obj.addEventListener('play', () => {
						if (!Obj) {
							return;
						}
						//console.log('触发Obj.play');
						//状态改为play
						status.playState = 3;
						status.isPlaying = true;
						status.isBuffering = false;
					});
					function onPause() {
						if (!Obj) {
							return;
						}
						//状态改为pause
						if (Obj && Obj?.currentTime === 0) {
							//停止状态
							status.playState = 1;
							status.isBuffering = false;
						} else {
							status.playState = 2;
							status.isBuffering = false;
						}
						status.isPlaying = false;
					}
					onPause();
					Obj.addEventListener('pause', onPause);
					Obj.addEventListener('loadstart', (event: any) => {
						//console.log('开始请求数据', event);
						if (!isCanPlay) {
							status.currentTime = 0;
							status.totalTime = -1;
							status.playState = 7;
							status.isBuffering = true;
							status.bufferTime = [];
						}
					});
					Obj.addEventListener('seeking', (event: any) => {
						isCanPlay = false;
						status.isSeeking = true;
						//console.log('seeking');
					});
					Obj.addEventListener('seeked', (event: any) => {
						touchBuffered();
						isCanPlay = true;
						status.isSeeking = false;
					});
					Obj.addEventListener('progress', (event: any) => {
						touchBuffered();
						if (!isCanPlay) {
							status.playState = 6;
							status.isBuffering = true;
						}
					});
					Obj.addEventListener('canplaythrough', (event: any) => {
						isCanPlay = true;
						//console.log('歌曲已经完成载入', event);
					});
					Obj.addEventListener('canplay', (event: any) => {
						//console.log('缓冲至目前可播放状态', event);
						//console.log('触发canplay');
						isCanPlay = true;
						if (status.isPlaying || (options.playlist && options.playlist.length > 0 && isOutCommandOTP)) {
							status.playState = 3;
							isOutCommandOTP = false;
						} else {
							onPause();
						}
						//status.playState = status.isPlaying ? 3 : onPause();
						status.isBuffering = false;
					});

					isInit = true;
					//如果是随机播放，则创建随机列表
					let targetTrack = 0;
					if (status.playMode === 3) {
						targetTrack = (() => {
							let res = Math.floor(Math.random() * playList.value.length);
							if (!playList.value[res]) {
								res = 0;
							}
							return res;
						})();
						createRandomList();
					}
					//console.log('第一首');
					if (options.isAutoPlay) {
						control('track', targetTrack); //播放第一首歌曲
						control('play');
					}
					//读取配置文件,如果不允许后台播放و，则监听窗口变化
					function onVisibilityChange() {
						if (document.hidden) {
							lastPlayStateForDocumentHidden = status.playState as number;
							control('pause');
						} else {
							if (lastPlayStateForDocumentHidden === 3) {
								control('play');
							}
						}
					}
					if (musicPlayerConfig.isAllowPlayingBackground === false) {
						onVisibilityChange();
						document.addEventListener('visibilitychange', onVisibilityChange);
					}
					//接收外部指令,必要，用于在未启用播放器时选择播放列表里的歌曲
					if (!isOnlyReceiveOutCommand) {
						receiveOutCommand(store.state.musicPlayerCommand);
						isOnlyReceiveOutCommand = true;
					}
					return this;
				})
				.catch(error => {
					$message.error(error);
				});
		};
		//卸载播放器
		const unistall = () => {
			isInit = false;
			randomList = [];
			try {
				document.body.appendChild(Obj);
				Obj.parentNode.removeChild(Obj);
			} catch (e) {
				//$message.error('无法完成卸载');
			}
			Obj = null;
		};
		//为随机播放建立数组
		const createRandomList = () => {
			const len = playList.value.length;
			const arr = [...new Array(len).keys()];
			for (let i = 0; i < 3; i++) {
				arr.sort(() => Math.random() - 0.5);
			}
			const findIndex = arr.findIndex(item => item === status.track);
			const temp = arr[0];
			arr[0] = arr[findIndex];
			arr[findIndex] = temp;
			randomList = [...arr];
		};
		//播放列表发生变化时，重建随机数组
		watch(
			() => playList.value,
			() => {
				if (status.playMode === 3) {
					createRandomList();
				}
			},
			{ immediate: true, deep: true }
		);

		//播放器的控制按钮
		const btns: Btns = reactive({
			control: [
				{
					key: 'prev',
					ico: 'skip-back',
					title: '上一首',
					methodName: 'prev',
				},
				{
					key: 'pp',
					ico: 'play-circle',
					title: '播放/暂停',
					methodName: 'togglePlayPause',
				},
				{
					key: 'next',
					ico: 'skip-forward',
					title: '下一首',
					methodName: 'next',
				},
			],
			extra: [
				{
					name: 'volume',
					title: '音量',
				},
			],
		});
		//功能块：解析歌词
		const parseLyric = (lrc: Lrc): Promise<Lyric[]> => {
			return new Promise((resolve, reject) => {
				//判断lrc的类型（直接歌词，lrc文件指针，外部资源）
				const lrcArr = lrc.split('\n');
				//console.log(lrcArr);
				let result = [{ time: 0, text: '' }];
				lrcArr.forEach((item: string, index) => {
					//分离出时间和文字
					const aTimes: number[] = (() => {
						const match = item.match(/\s*\n*\[.*?\]/g);
						//console.log(match);
						const aTimesResult: number[] = [];
						match?.forEach((item0: string) => {
							const rep = item0.replace(/(\[)|(\])/g, '');
							//console.log('rep', rep);
							let nRes = 0;
							rep.split(':')
								.reverse()
								.forEach((item1: string, index) => {
									nRes += Number(item1) * Math.pow(60, index);
								});
							if (!isNaN(nRes)) {
								aTimesResult.push(nRes);
							}
						});
						//console.log(aTimesResult);
						return aTimesResult;
					})();
					const text = item.replace(/\s*\n*\[.*?\]/g, '').replace('\r', '');
					aTimes.forEach(time => result.push({ time, text }));
				});
				//根据时间顺序进行排序
				result = result.sort((item, lastItem) => item.time - lastItem.time);
				resolve(result);
				//resolve([{ time: 1, text: '这是歌词' }]);
			});
		};
		//播放器的控制参数：播放、暂停等都在这里进行
		const control = (operate: string, options: any | undefined = undefined): void => {
			//判断播放器是否初始化
			if (!isInit) {
				//$message.warning('播放器未初始化');
				return;
			}
			//判断播放列表中有无歌曲
			//判断当前播放的资源
			switch (operate) {
				case 'track': {
					//修改变量
					isCanPlay = false;
					//如果指定了哪一首，则播放该歌曲，如果没有指定，则从第一首开始
					const t: number = typeof options === 'number' ? options : parseInt(status.track as any);
					//console.log('接收', t);
					if (!playList.value[t]) {
						$message.error('未找到对应歌曲');
						return;
					}
					status.track = t;
					nowPlay.value = playList.value[t];
					//解析歌词
					parseLyric(nowPlay.value.lrc)
						.then(data => (nowPlay.value.lyric = data))
						.catch(() => {
							/** */
						});
					if (!nowPlay.value.albumimg) {
						if (nowPlay.value.img) {
							nowPlay.value.albumimg = nowPlay.value.img;
						} else {
							nowPlay.value.albumimg = imgBenchUrl;
						}
					}
					(() => {
						const { url, source, netid } = nowPlay.value;
						if (url) {
							Obj.src = nowPlay.value.url;
						} else {
							//console.log(typeof source);
							if (typeof source === 'object' && source) {
								/*
								console.log(Array.from(source) as any[]);
								(Array.from(source) as any[]).forEach(item => {
									console.log('1111', item);
									if (item && typeof item === 'object' && item.type === 'local') {
										Obj.src = item.url;
									}
								});
								*/
								//alert(source[0].url);
								if (source[0] && typeof source[0] === 'object' && source[0].type === 'local') {
									Obj.src = source[0].url || `/upload/music/${source[0].source}.m4a`;
								}
							} else if (typeof source === 'string') {
								Obj.src = `/upload/music/${source}.m4a`;
							} else if (netid) {
								//状态改为等待
								//请求接口获取URL
								//更改当前URL
								//状态改为播放
							} else {
								$message.warning('无法获取歌曲资源，播放失败');
								Obj.src = '';
							}
						}
					})();
					//其他功能区的钩子
					if (typeof isAfterSelectedTime === 'boolean') {
						isAfterSelectedTime = false;
					}
					break;
				}
				case 'prev': {
					if (status.playMode === 3 && randomList.length !== playList.value.length) {
						$message.warning('因列表变化,无法执行随机播放');
					}
					let newTrack = 0;
					if (status.playMode === 3 && randomList.length === playList.value.length) {
						//如果是随机播放
						let newKey = randomList.findIndex(item => item === status.track) - 1;
						if (typeof randomList[newKey] !== 'number') {
							newKey = randomList.length - 1;
						}
						newTrack = randomList[newKey];
					} else {
						newTrack = (status.track as number) - 1;
						if (!playList.value[newTrack]) {
							newTrack = playList.value.length - 1;
						}
					}
					//$message.info('上一首');
					//console.log('上一首');
					control('track', newTrack);
					control('play');
					break;
				}
				case 'next': {
					//$message.info('下一首');
					//$modal('你有多久没有坚持做自己喜欢的事了');
					if (status.playMode === 3 && randomList.length !== playList.value.length) {
						$message.warning('因列表变化,无法执行随机播放');
					}
					let newTrack = 0;
					if (status.playMode === 3 && randomList.length === playList.value.length) {
						//如果是随机播放
						let newKey = randomList.findIndex(item => item === status.track) + 1;
						if (typeof randomList[newKey] !== 'number') {
							newKey = 0;
						}
						newTrack = randomList[newKey];
					} else {
						newTrack = (status.track as number) + 1;
						if (!playList.value[newTrack]) {
							newTrack = 0;
						}
					}
					//console.log('下一首');
					control('track', newTrack);
					control('play');
					break;
				}
				case 'autoNext': {
					//$message.success('自动播放下一首');
					//console.log('触发autoNext');
					control('toTime', 0);
					if (status.playMode === 1) {
						control('play');
					} else {
						control('next');
					}
					break;
				}
				case 'play':
					{
						const run = () => {
							status.isPlaying = true;
							const find = (btns as any)?.control?.find((item: any) => item.ico === 'play-circle');
							if (find) {
								find.ico = 'pause-circle';
							}
							if (!(typeof options === 'object' && options !== null && options.controlFromStore)) {
								store.commit('musicPlayerPauseOrPlay', false);
							}
						};
						if (typeof Obj !== 'object' || null === Obj) {
							$message.error('播放失败');
						}
						const playPromise = Obj?.play()
							?.then(() => {
								run();
								status.playState = 3;
							})
							?.catch((a: any) => {
								if (!isActivePage) {
									$message.warning('音频自动播放被浏览器阻止');
								} else {
									//$message.warning(`无法播放当前歌曲`);
								}
							})
							?.finally(() => {
								isActivePage = true;
							});
						if (!playPromise) {
							run();
						}
					}
					break;
				case 'pause':
					{
						//Obj.fade(1, 0, 500);
						//Obj.onfade = () => {
						//    Obj.pause();
						//};
						Obj.pause();
						if (!(typeof options === 'object' && options !== null && options.controlFromStore)) {
							store.commit('musicPlayerPauseOrPlay', true);
						}
						const find = (btns as any)?.control?.find((item: any) => item.ico === 'pause-circle');
						if (find) {
							find.ico = 'play-circle';
						}
						status.isPlaying = false;
					}
					break;
				case 'togglePlayPause':
					{
						if (status.isPlaying) {
							control('pause');
						} else {
							control('play');
						}
					}
					break;
				case 'volume': {
					if (typeof options === 'number') {
						options = options > 1 ? 1 : options < 0 ? 0 : options;
					} else {
						options = Obj.volume < 1 ? 1 : 0;
						//Obj.volume = Obj.volume < 1 ? 1 : 0;
						//status.volume = Obj.volume;
					}
					status.volume = Obj.volume = options;
					break;
				}
				case 'repeat': {
					(status as any).playMode += 1;
					if ((status as any).playMode > 3) {
						status.playMode = 1;
					}
					$tip.info(['', '单曲循环', '列表循环', '随机播放'][(status as any).playMode]);
					if (status.playMode === 3) {
						//如果是随机播放
						//创建随机列表
						createRandomList();
					} else {
						//清空随机列表
						randomList = [];
					}
					break;
				}
				case 'list': {
					if (!(config.isShowList && config.listScreenKey !== 2)) {
						config.isShowList = !config.isShowList;
					}
					config.listScreenKey = 2;
					break;
				}
				case 'playWindow': {
					//当前“正在播放”显示的界面，用于移动设备
					if (!(config.isShowList && ![0, 1].includes(config.listScreenKey as number))) {
						config.isShowList = !config.isShowList;
					}
					//console.log(Number(config.listScreenKey));
					if (config.isShowList) {
						config.listScreenKey = Number(config.listScreenKey) == 0 ? 1 : 0;
					}
					break;
				}
				case 'toTime': {
					if (!isCanPlay) {
						return;
					}
					isCanPlay = false;
					const time =
						typeof options === 'number'
							? options >= 0
								? options
								: (() => {
										$message.warning('时间无效' + options);
										return 0;
								  })()
							: 0;
					Obj.currentTime = time;
					break;
				}
				case 'download': {
					nowPlay.value.url ? window.open(nowPlay.value.url) : $message.warning('暂不支持');
					break;
				}
				case 'replaceListAndPlay': {
					if (typeof options !== 'object') {
						$message.warning('错误的操作');
						return;
					}
					if (typeof options.list !== 'object' || !options.list) {
						$message.warning('无效的播放列表');
					}
					//console.log(options);
					/*
					new Promise((resolve, reject) => {
						//
					})
						.then()
						.catch(() => {
							$message.warning('无法解析当前的列表');
						});
					*/
					//playList.value = options.list;
					init({ isAutoPlay: false, playlist: options.list })
						.then(() => {
							//console.log('成功重启');
							const findIndex = playList.value.findIndex(item => item.onlyid === options.playOnlyid);
							if (findIndex < 0) {
								$message.warning('未找到列表中对应的歌曲');
							}
							control('track', findIndex);
							control('play');
							config.isShowList = !config.isShowList;
							nextTick(() => (config.isShowList = !config.isShowList));
						})
						.catch(() => {
							//
						});
					break;
				}
				case 'addList': {
					//添加到播放列表，添加的位置（最后，下一首）
					if (typeof options !== 'object' || !options) {
						$message.warning('错误的操作');
						return;
					}
					//alert('执行');
					//console.log(options);
					const { addLocal, immediatePlay, data } = options;
					let nInsert: number; // = -1;
					if (isNaN(Number(addLocal))) {
						nInsert = -1;
					} else {
						nInsert = Number(addLocal);
					}
					if (nInsert !== -1 && nInsert !== -2) {
						nInsert = (playList.value.length + 1 + nInsert) % playList.value.length;
					}
					if (data) {
						if (nInsert === -1) {
							//在列表末尾插入
							playList.value.push(data);
						} else if (nInsert === -2) {
							//在下一首插入
							let nIns = status.track + 1;
							if (nIns < 0 || nIns > playList.value.length) {
								nIns = 0;
							}
							playList.value.splice(nIns, 0, data);
							//alert(immediatePlay);
							if (immediatePlay) {
								control('track', nIns);
								control('play');
							}
						} else {
							playList.value.splice(nInsert, 0, data);
						}
					}

					break;
				}
				default:
					$message.warning('无效的指令' + operate);
			}
		};
		const setConfig = (operate: string, options: any | undefined = undefined) => {
			switch (operate) {
				case 'toggleTimeRemaining': {
					config.isShowTimeRemaining = !config.isShowTimeRemaining;
					break;
				}
				default:
					$message.error('配置错误，请程序员重新调试');
			}
		};
		onMounted(() => {
			init();
			//监听
		});
		onBeforeUnmount(() => {
			unistall();
		});
		const progressDomTarget: Ref<any> = ref(null);
		const isWatchCurrentTime: Ref<boolean> = ref(true);
		const numberSelectedTime: Ref<number> = ref(-1);
		let isAfterSelectedTime = false;
		const getProgressWidth = (_progress: number, _numberSelectedTime: number | undefined = undefined): number | undefined => {
			if (!isWatchCurrentTime.value || (isAfterSelectedTime && status.playState === 6) || (isAfterSelectedTime && status.playState === 7) || (isAfterSelectedTime && status.isSeeking)) {
				return _numberSelectedTime;
			} else {
				//isAfterSelectedTime = false;
				return Math.ceil(progressDomTarget.value?.offsetWidth * (_progress > 1 ? 1 : _progress));
			}
		};
		const offsetXY = (event: any, target: any) => {
			event = event || window.event;
			const res = { x: 0, y: 0 };
			if (target && target.getBoundingClientRect) {
				const rect = target.getBoundingClientRect();
				res.x = event.pageX - rect.left;
				res.y = event.pageY - rect.top;
			}
			return res;
		};
		const toProgress = (event: any) => {
			//isWatchCurrentTime = true;
			const totalWidth = progressDomTarget.value?.offsetWidth || event.target.offsetWidth || -1;
			const x = offsetXY(event, progressDomTarget.value).x || event.offsetX;
			if (isNaN(x) || isNaN(totalWidth)) {
				return;
			}
			const progress = x / totalWidth;
			const targetTime = (status as any).totalTime * progress;
			control('toTime', targetTime);
			control('play');
		};

		const preProgress = (event: any) => {
			isWatchCurrentTime.value = false;
			numberSelectedTime.value = offsetXY(event, progressDomTarget.value).x;
			progressDomTarget.value.addEventListener('mousemove', preProgress);
			const documentMouseUp = () => {
				//继续监听
				//numberSelectedTime.value = -1;
				isWatchCurrentTime.value = true;
				isAfterSelectedTime = true;
				progressDomTarget.value.removeEventListener('mousemove', preProgress);
				document.documentElement.removeEventListener('mouseup', documentMouseUp);
			};
			document.documentElement.addEventListener('mouseup', documentMouseUp);
		};
		//监听是否要在详情页重置旋转的专辑图
		const refreshRotateImg: Ref<boolean> = ref(false);
		watch(
			() => nowPlay.value,
			() => {
				refreshRotateImg.value = true;
				nextTick(() => {
					refreshRotateImg.value = false;
				});
			}
		);
		//控制歌词滚动的部分
		const lyricAreaDom: Ref<any> = ref(null);
		const lyricAreaThisDom: Ref<any> = ref(null);
		const isDeterLyricAutoScroll: Ref<boolean> = ref(false);
		const lyricAreaPaddingPX: Ref<number> = ref(0);
		let lastLyricIndex = -2;
		const getLyricIndex = (): number => {
			if (typeof nowPlay.value.lyric !== 'object' || typeof nowPlay.value.lyric.length !== 'number' || nowPlay.value.lyric.length <= 0) {
				return -1;
			}
			const { lyric } = nowPlay.value;
			let res = -1;
			res = lyric.findIndex((item: any, index: any, arr: any) => {
				/*
                    console.log(arr);
                    item;
                    index;
                    arr;
                    */
				if (item.time <= (status as any).currentTime) {
					if (!arr[index + 1] || (arr[index + 1] && arr[index + 1].time && arr[index + 1].time > (status as any).currentTime)) {
						return true;
					}
				}
			});
			//自动滚动到对应的歌词
			if (lastLyricIndex !== res) {
				lastLyricIndex = res;
				nextTick(() => {
					/*
                    if (res === -1) {
                        lyricAreaThisDom.value &&
                            (lyricAreaThisDom.value.scrollTop = 0);
                        return;
                    }

                    */
					if (lyricAreaDom.value && lyricAreaThisDom.value) {
						/*
                        lyricAreaThisDom.value?.scrollIntoView({
                            behavior: 'smooth',
                        });
                        */
						//上下部分留出PADDING，以便歌词能够垂直居中显示
						const fullHeight = lyricAreaDom.value.offsetHeight;
						const p = lyricAreaThisDom.value.querySelector(`p[data-lyric-active]`);
						lyricAreaPaddingPX.value = fullHeight / 2;
						if (p && typeof p.getBoundingClientRect === 'function') {
							//const xy = offsetXY(p, lyricAreaThisDom.value);
							//console.log(xy);
							try {
								const targetTop =
									p.getBoundingClientRect().y + lyricAreaThisDom.value.scrollTop - lyricAreaThisDom.value.getBoundingClientRect().y - lyricAreaPaddingPX.value + p.clientHeight / 2;
								if (!isNaN(targetTop) && targetTop >= 0) {
									lyricAreaThisDom.value.scrollTop = targetTop;
									//兼容写法
									lyricAreaThisDom.value?.scrollTo(0, targetTop);
								}
							} catch (e) {
								//
							}
						}
					}
				});
			}
			return res;
		};
		watch(
			() => nowPlay.value,
			() => {
				if (lyricAreaThisDom.value) {
					lyricAreaThisDom.value.scrollTop = 0;
					lyricAreaThisDom.value?.scrollTo(0, 0);
				}
				//lyricAreaThisDom.value &&
				//    (lyricAreaThisDom.value.scrollTop = 0);
			}
		);
		watch(
			() => config.isShowList,
			() => {
				lastLyricIndex = -2;
			}
		);

		//兼容IE的部分
		if (isIE.value) {
			const blurCompatIE = async () => {
				//需要操作DOM
				const imageDOM: SVGImageElement | null = document.querySelector('[data-albumimg-compat-svg-image]');
				const parentDOM: SVGElement | null = document.querySelector('[data-albumimg-compat-svg]');
				if (
					!imageDOM ||
					!parentDOM ||
					typeof imageDOM.getBBox !== 'function' ||
					isNaN(parentDOM.clientWidth) ||
					isNaN(parentDOM.clientHeight) ||
					parentDOM.clientWidth == 0 ||
					parentDOM.clientHeight == 0
				) {
					//如果没有找到对应节点
					return;
				}

				const rect = imageDOM.getBBox();
				if (isNaN(rect.width) || isNaN(rect.height) || rect.width == 0 || rect.height == 0) {
					return;
				}
				const imgWH = [rect.width, rect.height];
				await new Promise((resolve, reject) => {
					const oImg = new Image();
					if (!nowPlay || !nowPlay.value || !nowPlay.value.albumimg) {
						reject('IE浏览器获取状态失败');
					}
					oImg.setAttribute('src', nowPlay.value.albumimg);
					oImg.addEventListener('load', () => {
						setTimeout(() => {
							if (oImg.width > 0 && oImg.height > 0) {
								resolve([oImg.width, oImg.height]);
							}
						}, 1);
					});
					oImg.addEventListener('error', error => {
						reject('无法处理的IE兼容性问题');
						console.warn('无法处理的IE兼容性问题', error);
					});
				})
					.then((wh: any) => {
						imgWH[0] = wh[0];
						imgWH[1] = wh[1];
					})
					.catch(error => {
						$message.warning('' + error);
					});
				const imgProportion = imgWH[0] / imgWH[1];
				const containerWH = [parentDOM.clientWidth, parentDOM.clientHeight];
				const containerProportion = containerWH[0] / containerWH[1];
				if (imgProportion > containerProportion) {
					//宽图
					//imageDOM.setAttribute('width','');
					//imageDOM.setAttribute('height',+'px');
					imageDOM.setAttribute('width', containerWH[1] * imgProportion + 'px');
					imageDOM.setAttribute('height', containerWH[1] + 'px');
					imageDOM.setAttribute(
						'x',
						'-' +
							(() => {
								return Math.abs((containerWH[1] * imgProportion - containerWH[1]) / 2);
							})()
					);
					imageDOM.setAttribute('y', '0');
				} else {
					//方图或窄图
					imageDOM.setAttribute('width', containerWH[0] + 'px');
					imageDOM.setAttribute('height', containerWH[0] / imgProportion + 'px');
					imageDOM.setAttribute('x', '0');
					imageDOM.setAttribute(
						'y',
						'-' +
							(() => {
								return Math.abs((containerWH[0] / imgProportion - containerWH[1]) / 2);
							})()
					);
				}
				/*
                imageDOM.setAttribute('width', '1366px');
                imageDOM.setAttribute('x', '-150');
                */
			};
			watch(
				() => nowPlay.value,
				() => {
					blurCompatIE();
				}
			);
			watch(
				() => config.isShowList,
				val => {
					val &&
						nextTick(() => {
							blurCompatIE();
						});
				}
			);

			let timer: number | undefined = undefined;
			onMounted(() => {
				timer = setInterval(() => {
					document.querySelectorAll('[data-image-object-fit-compat-ie]').forEach(item => {
						(objectFitImages as any)(item);
					});
				}, 100);
			});
			onBeforeUnmount(() => {
				clearInterval(timer);
			});
		}
		//监听其他组件发送给VUEX的数据以控制播放器的播放暂停
		watch(
			() => store.state.musicPlayerControl.otherComponentControlPause,
			(val, oldValue) => {
				//const val1 = val?.otherComponentControlPause;
				//console.log('播放器监听到了', val);
				if (val === 1) {
					control('pause', { controlFromStore: true });
				} else if (val === 0) {
					if (oldValue !== -1) {
						control('play', { controlFromStore: true });
					}
				}
			},
			{ deep: true }
		);

		//监听其他组件发送给VUEX的控制命令
		const receiveOutCommand = (value: any) => {
			//console.log('接收指令', value);
			isOutCommandOTP = true;
			if (value === '' || !value) {
				return;
			}
			const [_, command, dtl] = value.split('#');
			const dtlJson = dtl ? JSON.parse('' + dtl) : undefined;
			control(command, dtlJson);
		};
		watch(() => store.state.musicPlayerCommand, receiveOutCommand, { deep: true });
		onBeforeUnmount(() => {
			//将外部的播放器指令清空
			store.commit('musicPlayerControl', '');
		});

		//功能块，频谱
		const isCompactSpectrum: Ref<boolean> = ref(true);
		const spectrumDom: Ref<HTMLCanvasElement | null> = ref(null);
		(() => {
			let analyser: any = undefined;
			let intervalForSpectrum: number | undefined = undefined;
			window.AudioContext = window.AudioContext || (window as any).webkitAudioContext || (window as any).mozAudioContext;
			let random = Math.random();
			function drawCanvas(arr: Uint8Array) {
				try {
					if (spectrumDom.value) {
						spectrumDom.value.setAttribute('width', '242');
						spectrumDom.value.setAttribute('height', '242');
						const canvasContext = spectrumDom.value.getContext('2d')!;
						//console.log('绘画', canvasContext);
						//canvasContext.strokeStyle = ' #eb86a377';
						canvasContext.translate(121, 121);
						//创建一个线性渐变
						const lingrad = canvasContext.createLinearGradient(0, 0, 250, 0);
						let $colors = ['#dca8e2', '#f4d3e2', '#efefef'];
						if (document.documentElement.getAttribute('data-theme') === 'dark') {
							$colors = ['#a24374', '#420c28', '#101010'];
						}
						lingrad.addColorStop(0, $colors[0]);
						lingrad.addColorStop(0.35, $colors[1]);
						lingrad.addColorStop(0.6, $colors[2]);
						/*
						lingrad.addColorStop(0, '#eb86a377');
						lingrad.addColorStop(0.35, '#f864ae55');
						lingrad.addColorStop(0.7, '#f864ae33');
						lingrad.addColorStop(1, '#ffffff00');
						*/
						canvasContext.strokeStyle = lingrad;
						canvasContext.rotate(random * 180);

						for (let i = 0; i < 48; i++) {
							canvasContext.rotate(Math.PI / 24);
							canvasContext.beginPath();
							canvasContext.moveTo(96, 0);
							canvasContext.lineTo(
								100 +
									(() => {
										let res = Math.floor((arr[i] / 256) * 25);
										if (i < 12) {
											res = res * (1 - 0.3 * ((12 - i) / 12));
										} else if (i > 36) {
											const xx = (i - 36) / 12;
											res = res * (1 - xx) + (arr[0] / 256) * 25 * 0.7 * xx;
										}
										return res;
									})(),
								0
							);
							//canvasContext.lineJoin = ['round', 'bevel', 'miter'][0];
							canvasContext.lineJoin = 'round';
							canvasContext.lineWidth = 15;
							// cxt.strokeStyle = 'darkgrey'
							canvasContext.stroke();
							canvasContext.closePath();
						}
					}
				} catch (e) {
					//
				}
			}
			watch(
				() => config.isShowList,
				val => {
					if (val) {
						random = Math.random();
						try {
							try {
								analyser = (() => {
									const audioCtx = new AudioContext();
									const source = audioCtx.createMediaElementSource(Obj);
									const analyser = audioCtx.createAnalyser();
									source.connect(analyser);
									analyser.connect(audioCtx.destination);
									return analyser;
								})();
							} catch (e) {
								//
							}

							intervalForSpectrum = setInterval(() => {
								if (analyser && status.isPlaying) {
									analyser.fftSize = 128;
									const array = new Uint8Array(analyser.frequencyBinCount);
									analyser.getByteFrequencyData(array);
									//console.log(123);
									//console.log(array);
									drawCanvas(array);
								} else {
									//clearInterval(intervalForSpectrum);
								}
							}, 1000 / 24);
						} catch (e) {
							//如果不支持
							isCompactSpectrum.value = false;
						}
					} else {
						clearInterval(intervalForSpectrum);
					}
				}
			);
			onBeforeUnmount(() => clearInterval(intervalForSpectrum));
		})();

		return {
			isIE,
			...methods,
			btns,
			control,
			playList,
			nowPlay,
			status,
			config,
			setConfig,
			toProgress,
			preProgress,
			progressDomTarget,
			getProgressWidth,
			isWatchCurrentTime,
			numberSelectedTime,
			refreshRotateImg,
			getLyricIndex,
			lyricAreaDom,
			lyricAreaThisDom,
			isDeterLyricAutoScroll,
			lyricAreaPaddingPX,
			isCompactSpectrum,
			spectrumDom, //频谱的canvas
			imgBenchUrl, //默认的唱片图
		};
	},
});

/*
			{
				onlyid: 'd_7eb5f051d1f4585c9c073776d46113337d84e99f',
				title: '我们的歌',
				author: '丽江小倩',
				url: '/static/testmusic/我们的歌.mp3',
				albumimg: '/static/testmusic/丽江小倩.jpg',
			},
			*/
/*
			{
				title: '一瞬间',
				author: '丽江小倩',
				url: '/static/testmusic/一瞬间.flac',
				albumimg: '/static/testmusic/倩语倩寻.jpg',
			},
			{
				title: '柔软时光',
				author: '丽江小倩',
				url: '/static/testmusic/柔软时光.mp3',
				albumimg: '/static/testmusic/柔软时光.jpg',
			},*/
/*
            {
                title: '独角戏',
                author: '许茹芸',
                url: '/static/testmusic/独角戏.mp3',
                albumimg: '/static/testmusic/独角戏.jpg',
            },
            {
                title: '白月光',
                author: '张信哲',
                url: '/static/testmusic/白月光.flac',
                albumimg: '/static/testmusic/白月光.jpg',
            },
            {
                title: '明天你好',
                author: '牛奶@咖啡',
                url: '/static/testmusic/明天你好.flac',
                albumimg: '/static/testmusic/明天你好.jpg',
            },
            */
/*
            {
                title: '越长大越孤单',
                author: '牛奶@咖啡',
                url: '/static/testmusic/越长大越孤单.m4a',
                albumimg: '/static/testmusic/越长大越孤单.jpg',
            },
            {
                title: '栀子花开',
                author: '何炅',
                url: '/static/testmusic/栀子花开.m4a',
            },
            {
                title: '八年的爱',
                author: '冰冰超人',
                album: '八年的爱',
                url: '/static/testmusic/八年的爱.mp3',
                albumimg: '/static/testmusic/70215.jpg',
                lyric: [
                    { time: 0.2, text: '时光还在不停流荡' },
                    { time: 3.94, text: '每一份回忆都是用心收藏' },
                    { time: 9.55, text: '长大后我们一起仰望' },
                    { time: 14.66, text: '曾经的画面还是未赶上' },
                    { time: 21.58, text: '时间还在滴滴答答一直走个不停' },
                    { time: 24.11, text: '好多事情你还没有给我平等回应' },
                    { time: 26.87, text: '记得那天 我对你说你是我的命' },
                    { time: 29.18, text: '你说宝贝别闹 以后别再那么矫情' },
                    { time: 32.26, text: '午后的阳光 总是那么刺眼' },
                    { time: 34.5, text: '我知道 你也在悄悄为我改变' },
                    { time: 37.24, text: '再有几个小时我们也要走到白天' },
                    { time: 39.72, text: '唱的这首歌我只是想要纪念' },
                    { time: 42.83, text: '回忆过去 它是动人的故事' },
                    { time: 45.26, text: '异地恋的感情 我会努力学会维持' },
                    { time: 48.07, text: '八年之前我们做在同一个教室' },
                    { time: 50.53, text: '教科书上每页都有写上你的名字' },
                    { time: 53.55, text: '习惯走着你放学走过的那条小路' },
                    { time: 55.9, text: '另一个城市的你又身在何处' },
                    { time: 58.47, text: '朋友们也总是喜欢添油加醋' },
                    { time: 61.17, text: '我清楚 青春是场没有返程的旅途' },
                    { time: 64.05, text: '你总是跟我说 不要这么爱我' },
                    { time: 66.46, text: '人都是会变的 谁没了谁都能活' },
                    { time: 69.12, text: '或许吧你是怕我想太多会难过' },
                    { time: 71.72, text: '在你心里是否会有属于我的角落' },
                    { time: 74.78, text: '还记得曾经为你做过的那门功课' },
                    { time: 77.2, text: '还记得一起等的那辆133路公车' },
                    { time: 80.02, text: '还记得一起喝的那瓶百事可乐' },
                    { time: 82.41, text: '怀念你的味道和你手掌的温热' },
                ],
            },
            */
/*
			{
				title: '八年的爱',
				author: '冰冰超人',
				album: '八年的爱',
				url: '/static/testmusic/八年的爱.mp3',
				albumimg: '/static/testmusic/70215.jpg',
				lyric: [
					{ time: 0.2, text: '时光还在不停流荡' },
					{ time: 3.94, text: '每一份回忆都是用心收藏' },
					{ time: 9.55, text: '长大后我们一起仰望' },
					{ time: 14.66, text: '曾经的画面还是未赶上' },
					{ time: 21.58, text: '时间还在滴滴答答一直走个不停' },
					{ time: 24.11, text: '好多事情你还没有给我平等回应' },
					{ time: 26.87, text: '记得那天 我对你说你是我的命' },
					{ time: 29.18, text: '你说宝贝别闹 以后别再那么矫情' },
					{ time: 32.26, text: '午后的阳光 总是那么刺眼' },
					{ time: 34.5, text: '我知道 你也在悄悄为我改变' },
					{ time: 37.24, text: '再有几个小时我们也要走到白天' },
					{ time: 39.72, text: '唱的这首歌我只是想要纪念' },
					{ time: 42.83, text: '回忆过去 它是动人的故事' },
					{ time: 45.26, text: '异地恋的感情 我会努力学会维持' },
					{ time: 48.07, text: '八年之前我们做在同一个教室' },
					{ time: 50.53, text: '教科书上每页都有写上你的名字' },
					{ time: 53.55, text: '习惯走着你放学走过的那条小路' },
					{ time: 55.9, text: '另一个城市的你又身在何处' },
					{ time: 58.47, text: '朋友们也总是喜欢添油加醋' },
					{ time: 61.17, text: '我清楚 青春是场没有返程的旅途' },
					{ time: 64.05, text: '你总是跟我说 不要这么爱我' },
					{ time: 66.46, text: '人都是会变的 谁没了谁都能活' },
					{ time: 69.12, text: '或许吧你是怕我想太多会难过' },
					{ time: 71.72, text: '在你心里是否会有属于我的角落' },
					{ time: 74.78, text: '还记得曾经为你做过的那门功课' },
					{ time: 77.2, text: '还记得一起等的那辆133路公车' },
					{ time: 80.02, text: '还记得一起喝的那瓶百事可乐' },
					{ time: 82.41, text: '怀念你的味道和你手掌的温热' },
				],
			},
            {
                title: '挥着翅膀的女孩',
                author: '容祖儿',
                url: '/static/testmusic/挥着翅膀的女孩.mp3',
                albumimg: '/static/testmusic/19235955928205673.jpg',
                lyric: [
                    { time: 11.9, text: '当我还是一个懵懂的女孩' },
                    { time: 16.8, text: '遇到爱不懂爱' },
                    { time: 19.9, text: '从过去到现在' },
                    { time: 22.8, text: '直到他也离开留我在云海徘徊' },
                    { time: 28.7, text: '明白没人能取代' },
                    { time: 31.5, text: '他曾给我的信赖' },
                    {
                        time: 34.5,
                        text: 'See me fly',
                    },
                    {
                        time: 36.2,
                        text: 'I am proud to fly up high',
                    },
                    {
                        time: 39,
                        text: '不能一直依赖别人给我拥戴',
                    },
                    {
                        time: 45,
                        text: 'Believe me I can fly',
                    },
                    { time: 48, text: 'I am singing in the sky' },
                    { time: 50.7, text: '就算风雨覆盖我也不怕重来' },
                    { time: 59, text: '' },
                ],
            },
            {
                title: '相逢是首歌',
                author: '俞静',
                url: '/static/testmusic/相逢是首歌.mp3',
            },
            {
                title: '花开半夏',
                author: '爱朵女孩',
                url: '/static/testmusic/花开半夏.mp3',
                albumimg:
                    'https://p2.music.126.net/AZmj_pNfziozUnogyX3bqA==/2365049511407463.jpg?param=130y130',
            },
            {
                title: '红蜻蜓',
                author: '小虎队',
                url: '/static/testmusic/h.mp3',
                albumimg: 'http://127.0.0.1/avatar.png',
            },
            {
                onlyid: '002',
                title: '一生有你',
                author: '水木年华',
                url: 'http://127.0.0.1/jyyz511/source/music/m4a/32.一生有你.m4a',
                albumimg: 'http://127.0.0.1/app.jpg',
            },
            {
                onlyid: '003',
                title: '睁一只眼闭一只眼',
                author: '蔡依林',
                url: '/static/testmusic/睁一只眼闭一只眼.m4a',
                lyric_url: '/static/testmusic/睁一只眼闭一只眼.lrc',
                albumimg:
                    'http://127.0.0.1/upload/photo/4ae451e9hc913c3a582ed.jpg',
            },

            {
                onlyid: '004',
                title: '真心英雄',
                author: ['成龙'],
                url: '/static/testmusic/真心英雄.m4a',
                lyric_url: '/static/testmusic/真心英雄.lrc',
                albumimg:
                    'http://127.0.0.1/upload/photo/4ae451e9hc0121ed23f67.jpg',
                lyric: [
                    { time: 0, text: '' },
                    { time: 10.6, text: '在我心中曾经有一个梦' },
                    { time: 16.34, text: '要用歌声让你忘了所有的痛' },
                    { time: 20.29, text: '灿烂星空谁是真的英雄' },
                    { time: 26.87, text: '平凡的人们给我最多感动' },
                    { time: 31.2, text: '再没有恨也没有了痛' },
                    { time: 36.88, text: '但愿人间处处都有爱的影踪' },
                    { time: 40.89, text: '用我们的歌换你真心笑容' },
                    { time: 47.23, text: '祝福你的人生从此与众不同' },
                ],
            },
            */
/*
            {
                onlyid: '005',
                title: '折子戏',
                author: '黄阅',
                url: '/static/testmusic/折子戏.m4a',
                lyric_url: '/static/testmusic/折子戏.lrc',
                albumimg:
                    'http://127.0.0.1/upload/photo/4ae451e9hbee0f04aaa0e.jpg',
            },
            {
                onlyid: '006',
                title: '葬心',
                author: '周虹',
                url: '/static/testmusic/葬心.m4a',
                lyric_url: '/static/testmusic/葬心.lrc',
                //albumimg: 'http://127.0.0.1/avatar.png',
            },
            */

// || isIE.value
/*
            const blurCompatIE = function () {
                alert(1);

                //console.log('event', event);
                //const _this = event.taregt || event.srcElement || event.path[0];
                const _this = document.querySelector(
                    'div[data-albumimg-compat-svg-image]'
                )!;
                if (!_this) {
                    return;
                }
                //console.log('_this', _this);
                const rect =
                    _this && typeof (_this as any).getBBox === 'function'
                        ? (_this as any).getBBox()
                        : null;
                const parentNode = document.querySelector(
                    'div[data-music-player-detail-compat-with-ie]'
                )!;
                //console.log(parentNode);
                let preProportion = 1345 / 350;
                if (
                    parentNode &&
                    (parentNode as any).offsetWidth &&
                    (parentNode as any).offsetHeight
                ) {
                    preProportion =
                        (parentNode as any).offsetWidth /
                        (parentNode as any).offsetHeight;
                }
                let imageProportion = 1;
                if (rect && rect.width && rect.height) {
                    imageProportion = rect.width / rect.height;
                }
                if (imageProportion > preProportion) {
                    if (parentNode) {
                        parentNode.style.height = '100%';
                    }
                    //_this.setAttribute('x', '150');
                    //_this.setAttribute('y', '0');
                } else {
                    let bias = 0;
                    if (rect) {
                        bias =
                            (rect.height /
                                (rect.width / (parentNode as any).offsetWidth) -
                                (parentNode as any).offsetHeight) /
                            2;
                    }
                    
                    //_this.style.width = '100%';
                    //_this.setAttribute('x', '0');
                    //_this.setAttribute('y', '-' + bias);
                    
                    if (parentNode) {
                        parentNode.style.width =
                            (parentNode as any).offsetWidth + 'px';
                        parentNode.style.height =
                            (parentNode as any).offsetWidth / imageProportion +
                            'px';
                    }
                }
            };
            */
/*
            document
                .querySelectorAll('[data-image-object-fit-compat-ie]')
                .forEach(item => {
                    //alert('监听到变化');
                    item.addEventListener('load', () => {
                        //IE识别图像
                        (objectFitImages as any)(item);
                    });
                });
            window.addEventListener('resize', blurCompatIE);
            */

/*
                    (objectFitImages as any)(
                        document.querySelectorAll(
                            '[data-image-object-fit-compat-ie]'
                        )
                    );
                    */

/*
					const findIndex = playList.value.findIndex(item => item.onlyid === options.playOnlyid);
					console.log('播放曲目', findIndex);
					if (findIndex < 0) {
						$message.warning('未找到列表中对应的歌曲');
					}
					nextTick(() => {
						//control('track', findIndex);
						//control('play');
					});
					*/
